import { useState } from "react";
import { toast } from "sonner";
import authApis from "../../api/authApis";
import { FiTrash2 } from "react-icons/fi";

export default function DeleteAccount() {
  const [mobileOrEmail, setMobileOrEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [deleted, setDeleted] = useState(false);

  const handleDelete = async () => {
    if (!mobileOrEmail.trim()) {
      toast.error("Please enter mobile number or email");
      return;
    }

    try {
      setLoading(true);

      const response = await authApis.deleteAccount(mobileOrEmail);

      if (response?.status === 1) {
        setDeleted(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background-100 flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-14 shadow-sm border border-background-500 p-8 flex flex-col gap-6 animate-popup">
        <div className="flex flex-col items-center gap-3">
          <div className="w-16 h-16 rounded-full bg-error-50 flex items-center justify-center">
            <FiTrash2 className="text-error-500" size={28} />
          </div>

          <div className="text-center">
            <h1 className="text-2xl font-semibold text-neutral-500">
              Delete Account
            </h1>

            <p className="text-sm text-neutral-300 mt-2 leading-6">
              Enter your registered mobile number or email address to permanently
              delete your account.
            </p>
          </div>
        </div>

        {!deleted ? (
          <>
            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium text-neutral-400">
                Mobile Number / Email
              </label>

              <input
                type="text"
                value={mobileOrEmail}
                onChange={(e) => setMobileOrEmail(e.target.value)}
                placeholder="Enter mobile number or email"
                className="
                  w-full
                  rounded-10
                  border
                  border-background-600
                  px-4
                  py-3
                  text-sm
                  outline-none
                  transition-all
                  duration-200
                  focus:border-primary-500
                  focus:ring-2
                  focus:ring-primary-100
                "
              />
            </div>

            <button
              onClick={handleDelete}
              disabled={loading}
              className="
                w-full
                bg-error-600
                hover:bg-error-700
                text-white
                py-3
                rounded-10
                font-medium
                transition-all
                duration-200
                disabled:opacity-50
                disabled:cursor-not-allowed
              "
            >
              {loading ? "Deleting Account..." : "Delete Account"}
            </button>

            <div className="bg-warning-50 border border-warning-100 rounded-10 p-4">
              <p className="text-xs text-warning-700 leading-5">
                Warning: This action is irreversible. All your account data will
                be permanently removed.
              </p>
            </div>
          </>
        ) : (
          <div className="bg-success-50 border border-success-100 rounded-10 p-5 text-center">
            <h3 className="text-success-700 font-semibold text-lg">
              Account Deleted
            </h3>

            <p className="text-success-600 text-sm mt-2">
              Your account has been deleted successfully.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}